import { Organization } from "./organization";
import { Product } from "./product";

export class Assignment {
    id!: number;
    created_at!: Date;
    updated_at!: Date;
    created_by_id!: number;
    updated_by_id!: number;
    name!: string;
    salary_rules_id!: number;
    minimum_order!: number;
    description!: string;
    description_short!: string;
    description_local!: string;
    products: Product[] = []
    organizations: Organization[] = []
    picture!: string
    order_any_day!: boolean
    services: Product[] = []
    remote_work!: boolean
    slug!: string
    max_hours_per_day!: number
}
